import {useRoute} from '#imports';

export function useGetCompanyId(): string {
    const route = useRoute();
    const companyId = route.params.id;
    return companyId as string;
}
